import { __awaiter } from "tslib";
import { status } from '@/alas';
import { showError } from '@/store';
import { defineComponent, computed, onMounted, onUnmounted, reactive } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        let route = context.root.$route;
        // ================
        //
        // state
        //
        let $ = reactive({
            farm: status.fetch('farm'),
            types: status.fetch('types'),
            cycles: status.fetch('cycles')
        });
        // ================
        //
        // computed
        //
        let done = computed(() => $.farm.$o.fetch.done && $.cycles.o.fetch.done);
        // ================
        //
        // mounted
        //
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            try {
                let params = {
                    farmId: route.params.id
                };
                yield $.farm.$o.fetch.seek(params);
                yield $.types.o.fetch.seek();
                yield $.cycles.o.fetch.seek(params);
            }
            catch (error) {
                showError(error);
            }
        }));
        onUnmounted(() => {
            status.reset('farm');
            status.reset('cycles');
        });
        return {
            $,
            done
        };
    }
});
